<template>
  <div class="aha-footer">
    <template v-if="isPoweredByShowing && !isCtaShowing">
      <div class="powered-by">
        <a
          :href="poweredByURL"
          target="_blank"
          @click="trackPoweredByGAEvent"
          class="mr-3"
        >{{ $t("powerBy") }}</a>
        <a
          :href="termsURL"
          target="_blank"
          @click="trackTermsGAEvent"
          class="mr-3"
        >{{ $t("term") }}</a>
        <a
          :href="tutorialURL"
          target="_blank"
          @click="trackTutorialGAEvent"
        >{{ $t("Tutorials") }}</a>
      </div>
    </template>

    <AudienceCTA v-if="isCtaShowing && !isSkoleTube" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AudienceCTAContainer from '@/containers/footer/AudienceCTA'

import AudienceCTA from '@/components/footer/AudienceCTA.vue'
// utils

export default {
  components: {
    AudienceCTA: AudienceCTAContainer(AudienceCTA),

  },
  props: {
    isCtaShowing: {
      type: Boolean,
      default: false,
    },
    isPoweredByShowing: {
      type: Boolean,
      default: false,
    },
    poweredByURL: {
      type: String,
      default: '',
    },
    termsURL: {
      type: String,
      default: '',
    },
    tutorialURL: {
      type: String,
      default: '',
    },
    trackTermsGAEvent: {
      type: Function,
      default: () => {},
    },
    trackPoweredByGAEvent: {
      type: Function,
      default: () => {},
    },
    trackTutorialGAEvent: {
      type: Function,
      default: () => {},
    },
    isWhiteLabelUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slide,

      audienceId: (state) => state.audienceId,
      audienceTeam: (state) => {
        return state.presentation.teamData ?
          state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) : {}
      },
      isAudienceEmojiDisabled: (state) => state.isAudienceEmojiDisabled,

    }),

    hasQuizSlides() {
      return this.$store.state.slides &&
          this.$store.state.slides.length > 0 &&
          this.$store.state.slides.some((slide) => slide.type === 'pickAnswer')
    },

    canShowChatOnQRSlide() {
      return this.slideActive.type === 'qrcode' && this.hasQuizSlides
    },

    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },

    isSkoleTube() {
      try {
        const { identifyProvider } = this.presentation.user
        return identifyProvider === 'skoletube'
      } catch {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.aha-footer {
  width: 100%;
  box-sizing: border-box;
}

.powered-by {
  display: flex;
  justify-content: center;
  padding: 12px;
  font-size: 14px;
  color: inherit;

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
